import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export interface TabPanelClasses {
	/** Styles applied to the root element. */
	root: string;
	active: string;
	pad: string;
}

export function getTabPanelClass(slot: string) {
	return generateUtilityClass('TabPanel', slot);
}

export const tabPanelClasses = generateUtilityClasses('TabPanel', [
	'root',
	'active',
	'pad',
]);
export default tabPanelClasses;
